<template>
  <el-container class="ccrmp-demand">
    <el-header class="header-style">
      <el-divider content-position="left">云上公司注册用户需求</el-divider>
    </el-header>

    <el-main class="main-style">
      <el-table height="calc(100vh - 230px)" :data="tableData" style="width: 100%" border size="mini"
        :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }">
        <el-table-column prop="id" label="序号" width="80" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="用户" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.qyh_ali_user">
              {{ scope.row.qyh_ali_user.nickname }}
            </span>
            <span v-else-if="scope.row.ali_user">
              {{ scope.row.ali_user.nickname }}
            </span>
            <span v-else-if="scope.row.wc_user">
              {{ scope.row.wc_user.nickname }}
            </span>
            <span v-else-if="scope.row.bd_user">
              {{ scope.row.bd_user.nickname }}
            </span>
            <span v-else-if="scope.row.ali_qyh_user">
              {{ scope.row.ali_qyh_user.nickname }}
            </span>
            <span v-else-if="scope.row.ali_qyh_agent_user">
              {{ scope.row.ali_qyh_agent_user.nickname }}
            </span>
            <span v-else-if="scope.row.reg_now_user">
              {{ scope.row.reg_now_user.nickname }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="手机号" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.qyh_ali_user">
              <!-- {{ scope.row.qyh_ali_user.phone }} -->
              <phone-com :comPhone="scope.row.qyh_ali_user.phone" :vagaryPhone="scope.row.qyh_ali_user.vagary_phone"
                style="display: inline-block" />
            </span>
            <span v-else-if="scope.row.ali_user">
              <!-- {{ scope.row.ali_user.phone }} -->
              <phone-com :comPhone="scope.row.ali_user.phone" :vagaryPhone="scope.row.ali_user.vagary_phone"
                style="display: inline-block" />
            </span>
            <span v-else-if="scope.row.wc_user">
              <!-- {{ scope.row.wc_user.phone }} -->
              <phone-com :comPhone="scope.row.wc_user.phone" :vagaryPhone="scope.row.wc_user.vagary_phone"
                style="display: inline-block" />
            </span>
            <span v-else-if="scope.row.bd_user">
              <!-- {{ scope.row.bd_user.phone }} -->
              <phone-com :comPhone="scope.row.bd_user.phone" :vagaryPhone="scope.row.bd_user.vagary_phone"
                style="display: inline-block" />
            </span>
            <span v-else-if="scope.row.ali_qyh_user">
              <!-- {{ scope.row.ali_qyh_user.phone }} -->
              <phone-com :comPhone="scope.row.ali_qyh_user.phone" :vagaryPhone="scope.row.ali_qyh_user.vagary_phone"
                style="display: inline-block" />
            </span>
            <span v-else-if="scope.row.ali_qyh_agent_user">
              <!-- {{ scope.row.ali_qyh_agent_user.phone }} -->
              <phone-com :comPhone="scope.row.ali_qyh_agent_user.phone" :vagaryPhone="scope.row.ali_qyh_agent_user.vagary_phone"
                style="display: inline-block" />
            </span>
            <span v-else-if="scope.row.reg_now_user">
              <!-- {{ scope.row.ali_qyh_agent_user.phone }} -->
              <phone-com :comPhone="scope.row.reg_now_user.phone" :vagaryPhone="scope.row.reg_now_user.vagary_phone"
                style="display: inline-block" />
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="source" label="需求来源" align="center"> </el-table-column>
        <el-table-column prop="demand" label="用户需求" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="created_at" label="提交时间" align="center" width="140">
          <template slot-scope="scope">
            <!-- {{scope.row.created_at}} -->
            <date-formatter :date-value="scope.row.created_at"></date-formatter>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer-style">
      <el-pagination class="pagination-style" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="npage" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import DateFormatter from 'common/DateFormatter'
import PhoneCom from "common/PhoneCom";
export default {
  name: "QyhAdminCcrmpDemand",
  components: { DateFormatter, PhoneCom },
  data() {
    return {
      tableData: [],
      pageSize: 30,
      total: 0,
      npage: 1,
    };
  },

  mounted() {
    this.loadTable();
  },
  methods: {
    loadTable() {
      this.$axios
        .get("api/ccrmp_admin_get_user_demand?page=" + this.npage, {
          params: {
            perPage: this.pageSize,
          },
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.tableData = data.data.data;
            this.total = data.data.total;
          }
        })
        .catch();
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.npage = 1;
      this.pageSize = val;
      this.loadTable();
    },
    handleCurrentChange(val) {
      this.npage = val;
      this.loadTable();
    },
  },
};
</script>

<style scoped>
.ccrmp-demand {
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.footer-style {
  text-align: right;
}

.pagination-style {
  padding-top: 25px;
}

.main-style {
  padding: 0px !important;
  overflow-y: auto;
}

.header-style {
  height: 60px !important;
  padding: 0px !important;
}

.el-drawer__wrapper>>>.el-drawer {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/CcrmpDemand.vue